export default __webpack_public_path__ + "static/media/FAVICON_13.eb025fff.png";